import { atom } from 'recoil';

const composeAtomKey = (name: string) => `TimelineView_${name}`;

export const appointmentDropPositionXAtom = atom<Record<string, number> | null>(
  {
    key: composeAtomKey('appointmentDropPositionX'),
    default: null
  }
);

export const recurringTooltipIdAtom = atom<string>({
  key: composeAtomKey('recurringTooltipId'),
  default: ''
});
